// Como uma conversão se lê: data, custo e duração.
//
// Mora fora das telas porque a lista e o detalhe mostram os mesmos números, e
// duas cópias divergiriam na primeira vez que alguém mudasse a casa decimal.

export const formatGenerationDate = (value: string): string =>
	new Date(value).toLocaleString('pt-BR', {
		dateStyle: 'short',
		timeStyle: 'short',
	})

// O custo do pedido inteiro, e não a soma das questões: ler o caderno acontece
// uma vez, é a etapa mais cara do fluxo e não pertence a questão nenhuma.
// Quatro casas porque uma conversão inteira custa centavos.
export const formatGenerationCost = (value: number): string =>
	value > 0 ? `US$ ${Number(value).toFixed(4)}` : '—'

// Relógio de parede, do início à última questão. As questões rodam em paralelo,
// então somar as durações delas daria mais que o tempo real.
export const formatGenerationDuration = (value: number): string => {
	if (!value) {
		return '—'
	}

	const seconds = Math.round(value / 1000)

	return seconds < 60
		? `${seconds}s`
		: `${Math.floor(seconds / 60)}min ${String(seconds % 60).padStart(2, '0')}s`
}
